import axios from "axios";

import {
  reducerGetUnloadReportsPhotoFilters,
  reducerGetUserReportsFilters,
  reducerSelectedReports,
  reducerReportsStatus,
  reducerUserReports,
} from "../../reducer/userReports/reducers/userReports";
import { reducerGetScheduleFilters, reducerVisitScheduleInputValues } from "../../reducer/userSingleReport/reducers/visitSchedule";
import { AppDispatch } from "../../reducer/store";
import { getToken } from "../axiosToken";
import { reducerGetAllUsersList, reducerGetUsersList } from '../../reducer/accessRights/reducers/usersList';

const BASE_URL = process.env.REACT_APP_BASE_URL;

export const actionGetUserReports =
  (limit: number, page: number) =>
    async (dispatch: AppDispatch, getState: () => any) => {
      const { token } = await getToken();
      axios.defaults.headers.common["Authorization"] = token;
      const store = getState();
      const filter = store.userReports.userReports.reportsInputValues;
      try {
        const response = await axios.post(`${BASE_URL}/json/reports/list`, {
          limit,
          page,
          ...filter,
        });
        dispatch(reducerUserReports({ data: response.data, limit, page: 1 }));
      } catch (e: any) {
        if (e.response.status === 401) {
          window.location.href = "/login";
        }
      }
    };

export const actionGetUserReportsFilter =
  () => async (dispatch: AppDispatch, getState: () => any) => {
    const { token } = await getToken();
    axios.defaults.headers.common["Authorization"] = token;
    const store = getState();
     const filter = store.userSingleReport.visitSchedule;
    try {
      const response = await axios.get(`${BASE_URL}/json/reports/filters`);
      dispatch(reducerGetUserReportsFilters({ data: response.data }));
      dispatch(reducerGetScheduleFilters({ data: response.data }));
      dispatch(reducerVisitScheduleInputValues({ ...filter, contract: response.data[0].contracts[0] }));
    } catch {
      console.log('err');
    };
  };

export const actionUnloadReportsWithLinks =
  (data: any) => async (dispatch: AppDispatch) => {
    const { token } = await getToken();
    axios.defaults.headers.common["Authorization"] = token;

    try {
      const response = await axios.post(
        `${BASE_URL}/json/reports/export/report/links`,
        data
      );

      dispatch(
        reducerReportsStatus({
          reportsStatus: response.status,
          reportsRequestPurpose: "unloadWithLinks",
        })
      );
    } catch (err) {
      dispatch(
        reducerReportsStatus({
          reportsStatus: 0,
          reportsRequestPurpose: "unloadWithLinks",
        })
      );
    }
  };

export const actionUnloadReportsList =
  (data: any) => async (dispatch: AppDispatch) => {
    const { token } = await getToken();
    axios.defaults.headers.common["Authorization"] = token;

    try {
      const response = await axios.post(
        `${BASE_URL}/json/reports/export/report/list`,
        data
      );

      dispatch(
        reducerReportsStatus({
          reportsStatus: response.status,
          reportsRequestPurpose: "unloadReportsList",
        })
      );
    } catch (err) {
      dispatch(
        reducerReportsStatus({
          reportsStatus: 0,
          reportsRequestPurpose: "unloadReportsList",
        })
      );
    }
  };

export const actionUnloadReportsConsolidated =
  (data: any) => async (dispatch: AppDispatch) => {
    const { token } = await getToken();
    axios.defaults.headers.common["Authorization"] = token;

    try {
      const response = await axios.post(
        `${BASE_URL}/json/reports/export/report/consolidated`,
        data
      );

      dispatch(
        reducerReportsStatus({
          reportsStatus: response.status,
          reportsRequestPurpose: "unloadReportsConsolidated",
        })
      );
    } catch (err) {
      dispatch(
        reducerReportsStatus({
          reportsStatus: 0,
          reportsRequestPurpose: "unloadReportsConsolidated",
        })
      );
    }
  };

export const actionUnloadClientReport =
  (data: any) => async (dispatch: AppDispatch) => {
    const { token } = await getToken();
    axios.defaults.headers.common["Authorization"] = token;

    try {
      const response = await axios.post(
        `${BASE_URL}/json/reports/export/report/client`,
        data
      );

      dispatch(
        reducerReportsStatus({
          reportsStatus: response.status,
          reportsRequestPurpose: "unloadClientReport",
        })
      );
    } catch (err) {
      dispatch(
        reducerReportsStatus({
          reportsStatus: 0,
          reportsRequestPurpose: "unloadClientReport",
        })
      );
    }
  };

export const actionUnloadReportsPhotos =
  (data: any) => async (dispatch: AppDispatch) => {
    const { token } = await getToken();
    axios.defaults.headers.common["Authorization"] = token;

    try {
      const response = await axios.post(
        `${BASE_URL}/json/reports/export/photos`,
        data
      );

      dispatch(
        reducerReportsStatus({
          reportsStatus: response.status,
          reportsRequestPurpose: "unloadReportsPhotos",
        })
      );
    } catch (err) {
      dispatch(
        reducerReportsStatus({
          reportsStatus: 0,
          reportsRequestPurpose: "unloadReportsPhotos",
        })
      );
    }
  };

export const actionGetUnloadReportsPhotoFilter =
  (contractId: any) => async (dispatch: AppDispatch) => {
    const { token } = await getToken();
    axios.defaults.headers.common["Authorization"] = token;

    const response = await axios.get(
      `${BASE_URL}/json/reports/filters/photo/${contractId}`
    );

    dispatch(reducerGetUnloadReportsPhotoFilters({ data: response.data }));
  };

export const actionCreateGeo =
  (data: any) => async (dispatch: AppDispatch) => {
    const { token } = await getToken();
    axios.defaults.headers.common["Authorization"] = token;

    try {
      await axios.post(
        `${BASE_URL}/json/reports/geolocation/create/`,
        data
      );
    } catch (err) {
      dispatch(reducerSelectedReports([]));
    }
  };

export const actionCopyReports =
  (data: {
    date: string,
    reports: { id: number }
  }) => async (dispatch: AppDispatch) => {
    const { token } = await getToken();
    axios.defaults.headers.common["Authorization"] = token;

    try {
      const response = await axios.post(`${BASE_URL}/json/reports/copy`, data);

      dispatch(
        reducerReportsStatus({
          reportsStatus: response.status,
          reportsRequestPurpose: "copyReports",
        })
      );
    } catch (err) {
      dispatch(
        reducerReportsStatus({
          reportsStatus: 0,
          reportsRequestPurpose: "copyReports",
        })
      );
      dispatch(reducerSelectedReports([]));
    }
  };

export const actionUpdateDeliveryStatus =
  (data: any) => async (dispatch: AppDispatch) => {
    const { token } = await getToken();
    axios.defaults.headers.common["Authorization"] = token;

    try {
      const response = await axios.post(
        `${BASE_URL}/json/reports/delivery/update`,
        data
      );

      dispatch(
        reducerReportsStatus({
          reportsStatus: response.status,
          reportsRequestPurpose: "updateDeliveryStatus",
        })
      );
    } catch (err) {
      dispatch(
        reducerReportsStatus({
          reportsStatus: 0,
          reportsRequestPurpose: "updateDeliveryStatus",
        })
      );
      dispatch(reducerSelectedReports([]));
    }
  };

export const actionExportOsa = (data: any) => async (dispatch: AppDispatch) => {
  const { token } = await getToken();
  axios.defaults.headers.common["Authorization"] = token;

  try {
    const response = await axios.post(
      `${BASE_URL}/json/reports/export/osa`,
      data
    );

    dispatch(
      reducerReportsStatus({
        reportsStatus: response.status,
        reportsRequestPurpose: "osa",
      })
    );
    dispatch(reducerSelectedReports([]));
  } catch (err) {
    dispatch(
      reducerReportsStatus({
        reportsStatus: 0,
        reportsRequestPurpose: "osa",
      })
    );
    dispatch(reducerSelectedReports([]));
  }
};

export const actionExportAverageFacing =
  (data: any) => async (dispatch: AppDispatch) => {
    const { token } = await getToken();
    axios.defaults.headers.common["Authorization"] = token;

    try {
      const response = await axios.post(
        `${BASE_URL}/json/reports/export/averageFacing`,
        data
      );

      dispatch(
        reducerReportsStatus({
          reportsStatus: response.status,
          reportsRequestPurpose: "averageFacing",
        })
      );
      dispatch(reducerSelectedReports([]));
    } catch (err) {
      dispatch(
        reducerReportsStatus({
          reportsStatus: 0,
          reportsRequestPurpose: "averageFacing",
        })
      );
      dispatch(reducerSelectedReports([]));
    }
  };

export const actionShareOfShelf =
  (data: any) => async (dispatch: AppDispatch) => {
    const { token } = await getToken();
    axios.defaults.headers.common["Authorization"] = token;

    try {
      const response = await axios.post(
        `${BASE_URL}/json/reports/export/shareOfShelf`,
        data
      );

      dispatch(
        reducerReportsStatus({
          reportsStatus: response.status,
          reportsRequestPurpose: "shelfShare",
        })
      );
      dispatch(reducerSelectedReports([]));
    } catch (err) {
      dispatch(
        reducerReportsStatus({
          reportsStatus: 0,
          reportsRequestPurpose: "shelfShare",
        })
      );
      dispatch(reducerSelectedReports([]));
    }
  };

export const actionUnloadHotline =
  (data: any) => async (dispatch: AppDispatch) => {
    const { token } = await getToken();
    axios.defaults.headers.common["Authorization"] = token;

    try {
      const response = await axios.post(
        `${BASE_URL}/json/reports/export/hotline`,
        data
      );

      dispatch(
        reducerReportsStatus({
          reportsStatus: response.status,
          reportsRequestPurpose: "unloadHotline",
        })
      );
      dispatch(reducerSelectedReports([]));
    } catch (err) {
      dispatch(
        reducerReportsStatus({
          reportsStatus: 0,
          reportsRequestPurpose: "unloadHotline",
        })
      );
      dispatch(reducerSelectedReports([]));
    }
  };

export const actionUnloadCustomerReportsData =
  (data: any) => async (dispatch: AppDispatch) => {
    const { token } = await getToken();
    axios.defaults.headers.common["Authorization"] = token;

    try {
      const response = await axios.post(
        `${BASE_URL}/json/reports/export/client/report`,
        data
      );

      dispatch(
        reducerReportsStatus({
          reportsStatus: response.status,
          reportsRequestPurpose: "unloadCustomerReportsData",
        })
      );
      dispatch(reducerSelectedReports([]));
    } catch (err) {
      dispatch(
        reducerReportsStatus({
          reportsStatus: 0,
          reportsRequestPurpose: "unloadCustomerReportsData",
        })
      );
      dispatch(reducerSelectedReports([]));
    }
  };

export const actionUnloadCustomerReports =
  (data: any) => async (dispatch: AppDispatch) => {
    const { token } = await getToken();
    axios.defaults.headers.common["Authorization"] = token;

    try {
      const response = await axios.post(
        `${BASE_URL}/json/reports/export/reports`,
        data
      );

      dispatch(
        reducerReportsStatus({
          reportsStatus: response.status,
          reportsRequestPurpose: "unloadCustomerReports",
        })
      );
      dispatch(reducerSelectedReports([]));
    } catch (err) {
      dispatch(
        reducerReportsStatus({
          reportsStatus: 0,
          reportsRequestPurpose: "unloadCustomerReports",
        })
      );
      dispatch(reducerSelectedReports([]));
    }
  };

export const actionImportReportKPI =
  (files?: File[]) => async (dispatch: AppDispatch) => {
    const { token } = await getToken();
    const headers = {
      Authorization: token,
      "Content-Type": "multipart/form-data",
    };

    const formData = new FormData();

    files && files.forEach((file: File) => {
      formData.append("excelFile", file, file.name);
    });

    try {
      const response = await axios.put(
        `${BASE_URL}/json/reports/import/kpi`,
        formData,
        {
          headers: headers,
        }
      );
      dispatch(
        reducerReportsStatus({
          reportsStatus: response.status,
          reportsRequestPurpose: "uploadKPI",
        })
      );
    } catch (err) {
      dispatch(
        reducerReportsStatus({
          reportsStatus: 0,
          reportsRequestPurpose: "uploadKPI",
        })
      );
    }
  };
 
export const actionImportReportLogins =
(files?: File[]) => async (dispatch: AppDispatch) => {
  const { token } = await getToken();
  const headers = {
    Authorization: token,
    "Content-Type": "multipart/form-data",
  };

  const formData = new FormData();

  files && files.forEach((file: File) => {
    formData.append("excelFile", file, file.name);
  });

  try {
    const response = await axios.put(
      `${BASE_URL}/json/reports/import/logins`,
      formData,
      {
        headers: headers,
      }
    );
    dispatch(
      reducerReportsStatus({
        reportsStatus: response.status,
        reportsRequestPurpose: "logins",
      })
    );
  } catch (err) {
    dispatch(
      reducerReportsStatus({
        reportsStatus: 0,
        reportsRequestPurpose: "logins",
      })
    );
  }
};
export const actionGetEmployeesListConditionalAdmin = (data: any) => async (
  dispatch: AppDispatch
) => {
  const { token } = await getToken();
  axios.defaults.headers.common["Authorization"] = token;
  try {
    const response = await axios.post(
      `${BASE_URL}/json/reports/export/report/consolidated`,
      data
    );
    dispatch(reducerGetUsersList(response.data));
    dispatch(
      reducerReportsStatus({
        reportsStatus: response.status,
        reportsRequestPurpose: "unloadTander",
      })
    );
    dispatch(reducerGetAllUsersList(response.data));
    return response.data;
  } catch (error) {
    dispatch(
      reducerReportsStatus({
        reportsStatus: 0,
        reportsRequestPurpose: "unloadTander",
      })
    );
  }
};

export const actionGetEmployeesListConditionalClient = (data: any) => async (
  dispatch: AppDispatch
) => {
  const { token } = await getToken();
  axios.defaults.headers.common["Authorization"] = token;
  try {
    const response = await axios.post(
      `${BASE_URL}/json/reports/export/client/report`,
      data
    );
    dispatch(
      reducerReportsStatus({
        reportsStatus: response.status,
        reportsRequestPurpose: "unloadTander",
      })
    );
    dispatch(reducerGetAllUsersList(response.data));
    return response.data;
  } catch (error) {
    dispatch(
      reducerReportsStatus({
        reportsStatus: 0,
        reportsRequestPurpose: "unloadTander",
      })
    );
  }
};
export const actionGetEmployeesListConditional = (data: any) => async (
  dispatch: AppDispatch,
  getState: () => any
) => {
  const state = getState();
  const { claims } = state.user.user.data;
  if (claims && claims.includes("admin")) {
    return dispatch(actionGetEmployeesListConditionalAdmin(data));
  } else {
    return dispatch(actionGetEmployeesListConditionalClient(data));
  }
};

export const actionNewReportsCreation =
(files?: File[]) => async (dispatch: AppDispatch) => {
  const { token } = await getToken();
  const headers = {
    Authorization: token,
    "Content-Type": "multipart/form-data",
  };

  const formData = new FormData();

  files && files.forEach((file: File) => {
    formData.append("excelFile", file, file.name);
  });

  try {
    const response = await axios.put(
      `${BASE_URL}/json/reports/import/new`,
      formData,
      {
        headers: headers,
      }
    );
    dispatch(
      reducerReportsStatus({
        reportsStatus: response.status,
        reportsRequestPurpose: "newReportsCreation",
      })
    );
  } catch (err) {
    dispatch(
      reducerReportsStatus({
        reportsStatus: 0,
        reportsRequestPurpose: "newReportsCreation",
      })
    );
  }
};